import { z } from 'zod';

import {
  maximumMessageLength,
  maximumSalutationLength,
  maximumRecipientLength,
} from './Form/InputFields/constants';

const SALUTATION_LENGTH = parseInt(maximumSalutationLength);
const RECIPIENT_LENGTH = parseInt(maximumRecipientLength);
const MESSAGE_LINE_LENGTH = parseInt(maximumMessageLength);

export const Personalization = z
  .object({
    salutation: z.string().max(SALUTATION_LENGTH).optional().nullable(),
    recipient: z.string().max(RECIPIENT_LENGTH).optional().nullable(),
    messageLineOne: z.string().max(MESSAGE_LINE_LENGTH).optional().nullable(),
    messageLineTwo: z.string().max(MESSAGE_LINE_LENGTH).optional().nullable(),
    messageLineThree: z.string().max(MESSAGE_LINE_LENGTH).optional().nullable(),
    messageLineFour: z.string().max(MESSAGE_LINE_LENGTH).optional().nullable(),
    messageLineFive: z.string().max(MESSAGE_LINE_LENGTH).optional().nullable(),
    validFrom: z.string().optional().nullable(),
  })
  .optional()
  .nullable();

export const PersonalizationSchema = z.object({
  personalization: z.array(Personalization),
});
